import React, { SFC } from 'react'
import { Route } from 'react-router-dom'

import { renderRoute } from './guarded-route.helpers'
import { RouteGuardRenderProps } from './types'

type Props = RouteGuardRenderProps

export const GuardedRoute: SFC<Props> = ({ component, guards, canActivate, redirectTo, ...rest }) => {
  if (guards && (canActivate || redirectTo)) {
    throw new Error('GuardedRoute:props - you can use guards only or redirectTo with canActivate/canDeactive')
  }
  if (!guards && !canActivate) {
    throw new Error('GuardedRoute:props - one of {guards} or {canActivate},{redirectTo?} is mandatory')
  }

  return <Route {...rest} render={renderRoute({ component, guards, canActivate, redirectTo })} />
}



// WEBPACK FOOTER //
// ./src/modules/router/guarded-route.tsx